/** A routing hint only; never affects authorization or approval. */
export function inferFeedbackKind(message){
  if(/\b(spam|bedrägeri|bedragare|olaglig|abuse|scam)\b/iu.test(message))return 'report';
  if(/\b(bugg|bug|fel|error|trasig|broken|krasch|crash)\b|fungerar inte|kan inte|doesn.t work/iu.test(message))return 'problem';
  if(/\?\s*$/u.test(message))return 'question';
  return 'suggestion';
}
